export default __webpack_public_path__ + "static/media/add-icon.257ae4e2.svg";